import { browserHistory, hashHistory } from 'react-router';
import config from '../../../config/configureSettings';
// eslint-disable-next-line import/no-cycle
import { getLanguageFromURL } from './Internationalization';

let history = {};

export const getHistory = () => (config.useHashRouting ? hashHistory : browserHistory);
export const getHistor = () => history;
export const setHistory = (newHistory) => { history = newHistory; };

export const pushHistory = (path, delay) => {
  const hstory = getHistor();
  if (typeof delay === 'undefined') {
    hstory.push(path);
  } else {
    setTimeout(hstory.push.bind(null, path), delay);
  }
};

export const localizedPushHistory = (path, delay) => {
  const localizedPath = (path && path.startsWith('/')) ? `/${getLanguageFromURL()}${path}` : path;
  pushHistory(localizedPath, delay);
};
